import type { RelativeWorkspacePath } from "@codesandbox/pitcher-client";
import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

import { useCapabilities } from "./useCapabilities";

export type FocusFileMessage = {
  type: "FOCUS_FILE";
  visibleLines: [number, number];
  currentLine: number;
  filepath: RelativeWorkspacePath;
};

export type FollowHostEvent =
  | FocusFileMessage
  | {
      type: "FOLLOWER_JOINED";
      clientId: string;
    }
  | {
      type: "FOLLOWER_LEFT";
      clientId: string;
    };

export const useFollowChannel = () => {
  const pitcher = usePitcher();
  const pitcherCapabilities = useCapabilities();
  const [{ channel }, setFollowChannel] = useState(() => {
    if (!pitcherCapabilities.channel?.subscribe) {
      return { channel: null, state: null };
    }

    const channel = pitcher.clients.channel.getFollowChannel<FocusFileMessage>(
      // We call it workspace for backwards compatability with VSCode, this should be changed
      "WORKSPACE",
    );

    return {
      channel,
      // We return the state and subscribe to it so that React will update
      // when the state of following updates
      state: channel.state.following.get(),
    };
  });

  useEffect(() => {
    if (channel) {
      return channel.state.following.onTransition((newState) => {
        setFollowChannel(({ channel }) => ({
          state: newState,
          channel: channel!,
        }));
      });
    }
  }, []);

  return channel;
};
